/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_NewInputs */

const en_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const es_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo`)
};

const fr_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau`)
};

const de_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu`)
};

const ja_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新着`)
};

const zh_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新`)
};

const ar_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جديد`)
};

const id_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baru`)
};

const it_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo`)
};

const ru_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое`)
};

const pt_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo`)
};

const ko_badge_new = /** @type {(inputs: Badge_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신규`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Badge_NewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const badge_new = /** @type {((inputs?: Badge_NewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_NewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_badge_new(inputs)
	if (locale === "es") return es_badge_new(inputs)
	if (locale === "fr") return fr_badge_new(inputs)
	if (locale === "de") return de_badge_new(inputs)
	if (locale === "ja") return ja_badge_new(inputs)
	if (locale === "zh") return zh_badge_new(inputs)
	if (locale === "ar") return ar_badge_new(inputs)
	if (locale === "id") return id_badge_new(inputs)
	if (locale === "it") return it_badge_new(inputs)
	if (locale === "ru") return ru_badge_new(inputs)
	if (locale === "pt") return pt_badge_new(inputs)
	return ko_badge_new(inputs)
});